import { mkTrackAttrs } from '@/analytics/track';

const PREFIX = 'widget_menu' as const;

// Paper Finder Button
export const mkPaperFinderBtnTrackAttrs = (props: { isOpen: boolean }) =>
  mkTrackAttrs(`${PREFIX}__paper_finder_btn`, props);

// Reader Button
export const mkReaderBtnTrackAttrs = (props: { isOpen: boolean }) =>
  mkTrackAttrs(`${PREFIX}__reader_btn`, props);

// Report Button
export const mkReportBtnTrackAttrs = (props: { isOpen: boolean }) =>
  mkTrackAttrs(`${PREFIX}__report_btn`, props);

// Table Button
export const mkTableBtnTrackAttrs = (props: { isOpen: boolean }) =>
  mkTrackAttrs(`${PREFIX}__table_btn`, props);

// Data Voyager Button
export const mkDataVoyagerBtnTrackAttrs = (props: { isOpen: boolean }) =>
  mkTrackAttrs(`${PREFIX}__data_voyager_btn`, props);
